export const LANGUAGES = [
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
  { code: 'es', label: 'Español', dir: 'ltr' },
  { code: 'tr', label: 'Türkçe', dir: 'ltr' },
  { code: 'ur', label: 'اردو', dir: 'rtl' },
];

export const TRANSLATIONS = {
  ar: {
    appName: 'مطبخي',
    tagline: 'وصفات من بيتك إلى مذاقك',
    discover: 'اكتشف',
    favorites: 'المفضلة',
    search: 'بحث',
    shopping: 'التسوق',
    premium: 'مميز',
    tryFree: 'تجربة مجانية',
    weekPlan: 'خطة الأسبوع',
    tracker: 'متابعة السعرات',
    setupProfile: 'إعداد ملفك الشخصي',
    weight: 'الوزن (كغ)',
    height: 'الطول (سم)',
    age: 'العمر',
    gender: 'الجنس',
    male: 'ذكر', female: 'أنثى',
    activity: 'مستوى النشاط',
    sedentary: 'قليل الحركة', light: 'نشاط خفيف', moderate: 'نشاط متوسط', active: 'نشاط عالي',
    goal: 'الهدف',
    lose: 'إنقاص الوزن', maintain: 'المحافظة', gain: 'زيادة الوزن',
    save: 'حفظ',
    dailyTarget: 'هدفك اليومي',
    consumed: 'المستهلك',
    remaining: 'المتبقي',
    todayLog: 'سجل اليوم',
    addMeal: 'أضف وجبة',
    mealName: 'اسم الوجبة',
    customMeal: 'وجبة مخصصة',
    fromRecipe: 'من وصفة',
    weekHistory: 'آخر 7 أيام',
    profileSaved: 'تم حفظ الملف',
    mealAdded: 'تمت إضافة الوجبة',
    pickRecipe: 'اختر وصفة',
    buyTools: 'اشتر الأدوات',
    shop: 'تسوق',
    affiliateDisclosure: 'بعض الروابط تابعة قد نحصل منها على عمولة دون تكلفة إضافية عليك.',
    // Diet Convert
    dietConvert: 'حوّل الوصفة بالذكاء الاصطناعي',
    dietConvertHint: 'اختر نظاماً غذائياً ودعنا نعيد كتابة الوصفة لك (خاص بالمشتركين).',
    dietKeto: 'كيتو',
    dietVegan: 'نباتي صرف',
    dietVegetarian: 'نباتي',
    dietGlutenFree: 'خالٍ من الغلوتين',
    dietLowCarb: 'منخفض الكربوهيدرات',
    dietDairyFree: 'خالٍ من الألبان',
    converting: 'جاري التحويل...',
    convertedTitle: 'النسخة المُحوّلة',
    swaps: 'البدائل المُستخدمة',
    needPremium: 'هذه الميزة للمشتركين فقط',
    kcal: 'سعرة',
    perServing: 'للحصة',
    nutrition: 'القيمة الغذائية',
    protein: 'بروتين',
    carbs: 'كربوهيدرات',
    fat: 'دهون',
    // Theme / Support / Privacy / Trending / Share / Translate
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    support: 'الدعم الفني',
    privacyPolicy: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',
    trending: 'الأكثر مشاهدة',
    trendingHint: 'الوصفات التي شاهدها معظم المستخدمين',
    noTrending: 'لا توجد بيانات مشاهدة بعد',
    share: 'مشاركة',
    shareRecipe: 'شارك الوصفة',
    copyLink: 'نسخ الرابط',
    linkCopied: 'تم نسخ الرابط',
    translatePrompt: 'هذه الوصفة باللغة الإنجليزية — هل تريد ترجمتها؟',
    translateNow: 'ترجم الآن',
    translating: 'جاري الترجمة...',
    translated: 'تمت الترجمة',
    loginWithFacebook: 'تسجيل الدخول عبر فيسبوك',
    loginWithX: 'تسجيل الدخول عبر X',
    comingSoon: 'قريباً',
    or: 'أو',
    listen: 'استمع',
    listenWhole: 'استمع للوصفة كاملة',
    stop: 'إيقاف',
    voiceReader: 'القارئ الصوتي بالذكاء الاصطناعي',
    voiceReaderHint: 'استمع لخطوات الوصفة بصوت طبيعي بلغتك (للمشتركين فقط)',
    cookMode: 'وضع الطبخ بدون لمس',
    cookModeHint: 'يقرأ الخطوات ويبدأ المؤقت تلقائياً ثم ينتقل للخطوة التالية',
    cookDone: 'انتهت الوصفة! بالعافية',
    exit: 'إغلاق',
    paused: 'متوقف',
    phaseSpeaking: 'يقرأ الخطوة',
    phaseTimer: 'العد التنازلي',
    phaseGap: 'انتظار',
    voiceCommand: 'الأوامر الصوتية',
    updateAvailable: 'إصدار جديد متوفر',
    updateAvailableHint: 'لقد جلبنا تحديثاً جديداً للتطبيق — اضغط للتحديث.',
    updateNow: 'حدّث الآن',
    updateLater: 'لاحقاً',
    totalWeek: 'إجمالي الأسبوع',
    regenerate: 'خطة جديدة',
    savePlan: 'حفظ الخطة',
    addPlanShopping: 'أضف كل المكونات للتسوق',
    planSaved: 'تم حفظ الخطة',
    planAdded: 'تمت إضافة المكونات',
    day1: 'السبت', day2: 'الأحد', day3: 'الإثنين', day4: 'الثلاثاء', day5: 'الأربعاء', day6: 'الخميس', day7: 'الجمعة',
    profile: 'حسابي',
    login: 'تسجيل الدخول',
    loginWithGoogle: 'تسجيل الدخول بـ Google',
    logout: 'تسجيل الخروج',
    deleteAccount: 'حذف الحساب',
    deleteAccountTitle: 'حذف الحساب نهائياً',
    deleteAccountDesc: 'سيتم حذف حسابك وجميع بياناتك (الوصفات المفضلة، قوائم التسوق، خطط الأسبوع، سجلات السعرات) بشكل دائم ولا يمكن استرجاعها.',
    deleteAccountConfirm: 'نعم، احذف حسابي',
    cancel: 'إلغاء',
    accountDeleted: 'تم حذف حسابك بنجاح',
    deleteAccountFailed: 'تعذر حذف الحساب، حاول مجدداً',
    categories: 'الفئات',
    allRecipes: 'كل الوصفات',
    servings: 'عدد الأشخاص',
    prepTime: 'تحضير',
    cookTime: 'طبخ',
    minutes: 'د',
    ingredients: 'المقادير',
    tools: 'الأدوات',
    steps: 'خطوات التحضير',
    addToShopping: 'أضف إلى التسوق',
    addedToShopping: 'تمت الإضافة لقائمة التسوق',
    addAll: 'أضف الكل',
    startTimer: 'ابدأ المؤقت',
    pauseTimer: 'إيقاف',
    resetTimer: 'إعادة',
    next: 'التالي',
    prev: 'السابق',
    saveFav: 'حفظ في المفضلة',
    removeFav: 'إزالة من المفضلة',
    needLogin: 'سجل دخولك أولاً',
    searchByIngredients: 'البحث بالمكونات',
    searchByName: 'البحث بالاسم',
    namePlaceholder: 'اسم الوصفة مثلاً: منسف، شاورما، Pizza',
    typeIngredient: 'اكتب مكوناً واضغط إنتر',
    searchPlaceholder: 'مثال: بيض + طحين + حليب',
    searchBtn: 'بحث',
    matchedIngr: 'مكونات مطابقة',
    aiAssistant: 'مساعد الطبخ الذكي',
    aiAsk: 'اقترح لي وصفة',
    askPlaceholder: 'مثل: لدي بيض وجبنة، اقترح وصفة كيتو',
    diet: 'النظام الغذائي',
    dietAny: 'حسب الرغبة',
    dietKeto: 'كيتو',
    dietVegan: 'نباتي',
    dietHealthy: 'صحي',
    voiceCommand: 'أوامر صوتية',
    voiceListening: 'جاري الاستماع...',
    voiceHelp: 'قل: التالي، السابق، ابدأ المؤقت، أوقف',
    premiumTitle: 'افتح الوصفات المميزة',
    premiumDesc: 'وصفات احترافية وقوائم تسوق ذكية ودعم بدون إعلانات',
    monthly: 'شهرياً',
    subscribe: 'اشترك الآن',
    soonLabel: 'قريباً',
    startTrial: 'ابدأ تجربة مجانية 7 أيام',
    trialActive: 'تجربتك المجانية نشطة',
    trialDays: 'أيام مجانية',
    shoppingEmpty: 'قائمة التسوق فارغة',
    addItem: 'أضف عنصر',
    itemName: 'اسم المكون',
    qty: 'الكمية',
    bought: 'تم الشراء',
    remove: 'حذف',
    onlineShop: 'اطلب أونلاين',
    favEmpty: 'لم تحفظ وصفات بعد',
    backHome: 'الرئيسية',
    welcomeBack: 'مرحباً بعودتك',
    loginDesc: 'سجل دخولك لتحفظ وصفاتك المفضلة وقوائم التسوق',
    suggested: 'مقترحات لك',
    explore: 'استكشف',
    timerDone: 'انتهى الوقت!',
    step: 'خطوة',
    of: 'من',
    settings: 'الإعدادات',
    language: 'اللغة',
    send: 'إرسال',
    aiThinking: 'يفكر...',
  },
  en: {
    appName: 'Matbakhi',
    tagline: 'Recipes from your kitchen to your taste',
    discover: 'Discover',
    favorites: 'Favorites',
    search: 'Search',
    shopping: 'Shopping',
    premium: 'Premium',
    tryFree: 'Try Free',
    weekPlan: 'Week Plan',
    tracker: 'Calorie Tracker',
    setupProfile: 'Set up your profile',
    weight: 'Weight (kg)', height: 'Height (cm)', age: 'Age',
    gender: 'Gender', male: 'Male', female: 'Female',
    activity: 'Activity level',
    sedentary: 'Sedentary', light: 'Light', moderate: 'Moderate', active: 'Active',
    goal: 'Goal',
    lose: 'Lose weight', maintain: 'Maintain', gain: 'Gain weight',
    save: 'Save',
    dailyTarget: 'Daily target',
    consumed: 'Consumed', remaining: 'Remaining',
    todayLog: "Today's log",
    addMeal: 'Add meal', mealName: 'Meal name',
    customMeal: 'Custom meal', fromRecipe: 'From recipe',
    weekHistory: 'Last 7 days',
    profileSaved: 'Profile saved', mealAdded: 'Meal added',
    pickRecipe: 'Pick a recipe',
    buyTools: 'Buy the tools', shop: 'Shop',
    affiliateDisclosure: 'Some links are affiliate links; we may earn a commission at no extra cost to you.',
    dietConvert: 'AI Recipe Conversion',
    dietConvertHint: 'Pick a diet and let AI rewrite this recipe for you (Premium only).',
    dietKeto: 'Keto',
    dietVegan: 'Vegan',
    dietVegetarian: 'Vegetarian',
    dietGlutenFree: 'Gluten-Free',
    dietLowCarb: 'Low-Carb',
    dietDairyFree: 'Dairy-Free',
    // Theme / Support / Privacy / Trending / Share / Translate
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    support: 'Support',
    privacyPolicy: 'Privacy Policy',
    lastUpdated: 'Last updated',
    trending: 'Trending',
    trendingHint: 'Recipes most viewed by users',
    noTrending: 'No view data yet',
    share: 'Share',
    shareRecipe: 'Share this recipe',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    translatePrompt: 'This recipe is in English — translate it?',
    translateNow: 'Translate now',
    translating: 'Translating...',
    translated: 'Translation ready',
    loginWithFacebook: 'Sign in with Facebook',
    loginWithX: 'Sign in with X',
    comingSoon: 'Coming soon',
    or: 'or',
    listen: 'Listen',
    listenWhole: 'Listen to full recipe',
    stop: 'Stop',
    voiceReader: 'AI Voice Reader',
    voiceReaderHint: 'Listen to the steps in natural voice in your language (Premium only)',
    cookMode: 'Hands-free Cook Mode',
    cookModeHint: 'Reads each step, auto-starts the timer, and advances to the next step',
    cookDone: 'Recipe complete! Bon appétit',
    exit: 'Close',
    paused: 'Paused',
    phaseSpeaking: 'Reading step',
    phaseTimer: 'Countdown',
    phaseGap: 'Up next',
    updateAvailable: 'New version available',
    updateAvailableHint: 'A fresh app update is ready — tap to load it.',
    updateNow: 'Update now',
    updateLater: 'Later',
    converting: 'Converting...',
    convertedTitle: 'Converted version',
    swaps: 'Ingredient swaps',
    needPremium: 'Premium subscription required',
    kcal: 'kcal',
    perServing: 'per serving',
    nutrition: 'Nutrition',
    protein: 'Protein',
    carbs: 'Carbs',
    fat: 'Fat',
    totalWeek: 'Weekly total',
    regenerate: 'New plan',
    savePlan: 'Save plan',
    addPlanShopping: 'Add all ingredients to shopping',
    planSaved: 'Plan saved',
    planAdded: 'Ingredients added',
    day1: 'Saturday', day2: 'Sunday', day3: 'Monday', day4: 'Tuesday', day5: 'Wednesday', day6: 'Thursday', day7: 'Friday',
    profile: 'Profile',
    login: 'Sign in',
    loginWithGoogle: 'Continue with Google',
    logout: 'Sign out',
    deleteAccount: 'Delete account',
    deleteAccountTitle: 'Permanently delete account',
    deleteAccountDesc: 'Your account and all data (favourites, shopping lists, week plans, calorie logs) will be deleted permanently and cannot be recovered.',
    deleteAccountConfirm: 'Yes, delete my account',
    cancel: 'Cancel',
    accountDeleted: 'Your account has been deleted',
    deleteAccountFailed: 'Could not delete account, please try again',
    categories: 'Categories',
    allRecipes: 'All Recipes',
    servings: 'Servings',
    prepTime: 'Prep',
    cookTime: 'Cook',
    minutes: 'min',
    ingredients: 'Ingredients',
    tools: 'Tools',
    steps: 'Steps',
    addToShopping: 'Add to shopping',
    addedToShopping: 'Added to shopping list',
    addAll: 'Add all',
    startTimer: 'Start timer',
    pauseTimer: 'Pause',
    resetTimer: 'Reset',
    next: 'Next',
    prev: 'Previous',
    saveFav: 'Save to favorites',
    removeFav: 'Remove favorite',
    needLogin: 'Please sign in first',
    searchByIngredients: 'Search by ingredients',
    searchByName: 'Search by name',
    namePlaceholder: 'Recipe name e.g. Mansaf, Pizza, Lasagna',
    typeIngredient: 'Type an ingredient and press Enter',
    searchPlaceholder: 'e.g. egg + flour + milk',
    searchBtn: 'Search',
    matchedIngr: 'matched',
    aiAssistant: 'AI Cooking Assistant',
    aiAsk: 'Suggest a recipe',
    askPlaceholder: "e.g. I have eggs and cheese, suggest a keto recipe",
    diet: 'Diet',
    dietAny: 'Any',
    dietKeto: 'Keto',
    dietVegan: 'Vegan',
    dietHealthy: 'Healthy',
    voiceCommand: 'Voice commands',
    voiceListening: 'Listening...',
    voiceHelp: 'Say: next, previous, start timer, stop',
    premiumTitle: 'Unlock premium recipes',
    premiumDesc: 'Chef recipes, smart shopping lists, ad-free experience',
    monthly: '/month',
    subscribe: 'Subscribe',
    soonLabel: 'Coming soon',
    startTrial: 'Start 7-day free trial',
    trialActive: 'Free trial active',
    trialDays: 'free days',
    shoppingEmpty: 'Your shopping list is empty',
    addItem: 'Add item',
    itemName: 'Item name',
    qty: 'Qty',
    bought: 'Bought',
    remove: 'Remove',
    onlineShop: 'Order online',
    favEmpty: 'No favorites yet',
    backHome: 'Home',
    welcomeBack: 'Welcome back',
    loginDesc: 'Sign in to save favorites and shopping lists',
    suggested: 'Suggested for you',
    explore: 'Explore',
    timerDone: 'Time is up!',
    step: 'Step',
    of: 'of',
    settings: 'Settings',
    language: 'Language',
    send: 'Send',
    aiThinking: 'Thinking...',
  },
  fr: {
    appName: 'Matbakhi',
    tagline: 'Des recettes de votre cuisine à votre goût',
    discover: 'Découvrir', favorites: 'Favoris', search: 'Recherche', shopping: 'Courses',
    premium: 'Premium',
    weekPlan: 'Plan semaine', tracker: 'Calories',
    setupProfile: 'Profil', weight: 'Poids (kg)', height: 'Taille (cm)', age: 'Âge',
    gender: 'Sexe', male: 'Homme', female: 'Femme',
    activity: 'Activité', sedentary: 'Sédentaire', light: 'Léger', moderate: 'Modéré', active: 'Actif',
    goal: 'Objectif', lose: 'Perdre', maintain: 'Maintenir', gain: 'Gagner',
    save: 'Enregistrer', dailyTarget: 'Objectif jour', consumed: 'Consommé', remaining: 'Restant',
    todayLog: "Journal d'aujourd'hui", addMeal: 'Ajouter repas', mealName: 'Nom du repas',
    customMeal: 'Repas perso', fromRecipe: 'Depuis recette', weekHistory: '7 derniers jours',
    profileSaved: 'Profil enregistré', mealAdded: 'Repas ajouté', pickRecipe: 'Choisir une recette', kcal: 'kcal', perServing: 'par portion', nutrition: 'Nutrition',
    protein: 'Protéines', carbs: 'Glucides', fat: 'Lipides', totalWeek: 'Total semaine',
    regenerate: 'Nouveau plan', savePlan: 'Enregistrer', addPlanShopping: 'Ajouter tous les ingrédients',
    planSaved: 'Plan enregistré', planAdded: 'Ingrédients ajoutés',
    day1: 'Samedi', day2: 'Dimanche', day3: 'Lundi', day4: 'Mardi', day5: 'Mercredi', day6: 'Jeudi', day7: 'Vendredi',
    profile: 'Profil', login: 'Connexion',
    loginWithGoogle: 'Continuer avec Google', logout: 'Déconnexion',
    categories: 'Catégories', allRecipes: 'Toutes les recettes', servings: 'Portions',
    prepTime: 'Prép.', cookTime: 'Cuisson', minutes: 'min',
    ingredients: 'Ingrédients', tools: 'Ustensiles', steps: 'Étapes',
    addToShopping: 'Ajouter aux courses', addedToShopping: 'Ajouté aux courses',
    addAll: 'Tout ajouter', startTimer: 'Démarrer', pauseTimer: 'Pause', resetTimer: 'Reset',
    next: 'Suivant', prev: 'Précédent', saveFav: 'Sauver', removeFav: 'Retirer',
    needLogin: "Connectez-vous d'abord", searchByIngredients: 'Recherche par ingrédients',
    typeIngredient: 'Tapez un ingrédient', searchPlaceholder: 'ex: œuf + farine + lait',
    searchBtn: 'Rechercher', matchedIngr: 'correspondants',
    aiAssistant: 'Assistant IA', aiAsk: 'Suggère-moi une recette',
    askPlaceholder: "ex: j'ai des œufs et du fromage", diet: 'Régime',
    dietAny: 'Aucun', dietKeto: 'Keto', dietVegan: 'Végan', dietHealthy: 'Sain',
    voiceCommand: 'Commandes vocales', voiceListening: 'Écoute...',
    voiceHelp: 'Dites: suivant, précédent, start',
    premiumTitle: 'Recettes premium', premiumDesc: 'Recettes de chef, sans pub',
    monthly: '/mois', subscribe: "S'abonner", soonLabel: 'Bientôt',
    startTrial: 'Essai gratuit 7 jours', trialActive: 'Essai actif', trialDays: 'jours offerts',
    shoppingEmpty: 'Liste vide', addItem: 'Ajouter', itemName: 'Nom', qty: 'Qté',
    bought: 'Acheté', remove: 'Supprimer', onlineShop: 'Commander en ligne',
    favEmpty: 'Aucun favori', backHome: 'Accueil',
    welcomeBack: 'Bon retour', loginDesc: 'Connectez-vous pour sauvegarder',
    suggested: 'Suggéré', explore: 'Explorer', timerDone: 'Terminé !',
    step: 'Étape', of: 'sur', settings: 'Réglages', language: 'Langue',
    send: 'Envoyer', aiThinking: 'Réflexion...',
  },
  es: {
    appName: 'Matbakhi', tagline: 'Recetas de tu cocina a tu gusto',
    discover: 'Descubrir', favorites: 'Favoritos', search: 'Buscar', shopping: 'Compras',
    premium: 'Premium',
    weekPlan: 'Plan semanal', tracker: 'Calorías',
    setupProfile: 'Perfil', weight: 'Peso (kg)', height: 'Altura (cm)', age: 'Edad',
    gender: 'Sexo', male: 'Hombre', female: 'Mujer',
    activity: 'Actividad', sedentary: 'Sedentaria', light: 'Ligera', moderate: 'Moderada', active: 'Activa',
    goalLabel: 'Objetivo', lose: 'Bajar', maintain: 'Mantener', gain: 'Subir',
    save: 'Guardar', dailyTarget: 'Meta diaria', consumed: 'Consumido', remaining: 'Restante',
    todayLog: 'Registro de hoy', addMeal: 'Añadir comida', mealName: 'Nombre',
    customMeal: 'Personalizada', fromRecipe: 'De receta', weekHistory: 'Últimos 7 días',
    profileSaved: 'Perfil guardado', mealAdded: 'Comida añadida', pickRecipe: 'Elegir receta',
    kcal: 'kcal', perServing: 'por porción', nutrition: 'Nutrición',
    protein: 'Proteína', carbs: 'Carbohidratos', fat: 'Grasas', totalWeek: 'Total semanal',
    regenerate: 'Nuevo plan', savePlan: 'Guardar', addPlanShopping: 'Añadir todos los ingredientes',
    planSaved: 'Plan guardado', planAdded: 'Ingredientes añadidos',
    day1: 'Sábado', day2: 'Domingo', day3: 'Lunes', day4: 'Martes', day5: 'Miércoles', day6: 'Jueves', day7: 'Viernes',
    profile: 'Perfil', login: 'Iniciar sesión',
    loginWithGoogle: 'Continuar con Google', logout: 'Cerrar sesión',
    categories: 'Categorías', allRecipes: 'Todas', servings: 'Porciones',
    prepTime: 'Prep', cookTime: 'Cocción', minutes: 'min',
    ingredients: 'Ingredientes', tools: 'Utensilios', steps: 'Pasos',
    addToShopping: 'Añadir a compras', addedToShopping: 'Añadido',
    addAll: 'Añadir todo', startTimer: 'Iniciar', pauseTimer: 'Pausar', resetTimer: 'Reiniciar',
    next: 'Siguiente', prev: 'Anterior', saveFav: 'Guardar', removeFav: 'Quitar',
    needLogin: 'Inicia sesión', searchByIngredients: 'Buscar por ingredientes',
    typeIngredient: 'Escribe un ingrediente', searchPlaceholder: 'ej: huevo + harina',
    searchBtn: 'Buscar', matchedIngr: 'coincidencias',
    aiAssistant: 'Asistente IA', aiAsk: 'Sugiere una receta',
    askPlaceholder: 'ej: tengo huevos y queso', diet: 'Dieta',
    dietAny: 'Cualquiera', dietKeto: 'Keto', dietVegan: 'Vegano', dietHealthy: 'Saludable',
    voiceCommand: 'Comandos de voz', voiceListening: 'Escuchando...',
    voiceHelp: 'Di: siguiente, anterior, iniciar',
    premiumTitle: 'Recetas premium', premiumDesc: 'Recetas de chef sin anuncios',
    monthly: '/mes', subscribe: 'Suscribirse', soonLabel: 'Pronto',
    startTrial: 'Prueba gratis 7 días', trialActive: 'Prueba activa', trialDays: 'días gratis',
    shoppingEmpty: 'Lista vacía', addItem: 'Añadir', itemName: 'Nombre', qty: 'Cant.',
    bought: 'Comprado', remove: 'Quitar', onlineShop: 'Pedir online',
    favEmpty: 'Sin favoritos', backHome: 'Inicio',
    welcomeBack: 'Bienvenido', loginDesc: 'Inicia sesión para guardar',
    suggested: 'Sugerido', explore: 'Explorar', timerDone: '¡Tiempo!',
    step: 'Paso', of: 'de', settings: 'Ajustes', language: 'Idioma',
    send: 'Enviar', aiThinking: 'Pensando...',
  },
  tr: {
    appName: 'Matbakhi', tagline: 'Mutfağınızdan damak tadınıza tarifler',
    discover: 'Keşfet', favorites: 'Favoriler', search: 'Ara', shopping: 'Alışveriş',
    premium: 'Premium',
    weekPlan: 'Haftalık plan', tracker: 'Kalori',
    setupProfile: 'Profil', weight: 'Kilo (kg)', height: 'Boy (cm)', age: 'Yaş',
    gender: 'Cinsiyet', male: 'Erkek', female: 'Kadın',
    activity: 'Aktivite', sedentary: 'Hareketsiz', light: 'Hafif', moderate: 'Orta', active: 'Aktif',
    goal: 'Hedef', lose: 'Kilo ver', maintain: 'Koru', gain: 'Kilo al',
    save: 'Kaydet', dailyTarget: 'Günlük hedef', consumed: 'Tüketilen', remaining: 'Kalan',
    todayLog: 'Bugünün kaydı', addMeal: 'Öğün ekle', mealName: 'Öğün adı',
    customMeal: 'Özel', fromRecipe: 'Tariften', weekHistory: 'Son 7 gün',
    profileSaved: 'Profil kaydedildi', mealAdded: 'Öğün eklendi', pickRecipe: 'Tarif seç', kcal: 'kcal', perServing: 'porsiyon başına', nutrition: 'Besin',
    protein: 'Protein', carbs: 'Karbonhidrat', fat: 'Yağ', totalWeek: 'Haftalık toplam',
    regenerate: 'Yeni plan', savePlan: 'Kaydet', addPlanShopping: 'Tüm malzemeleri ekle',
    planSaved: 'Plan kaydedildi', planAdded: 'Malzemeler eklendi',
    day1: 'Cumartesi', day2: 'Pazar', day3: 'Pazartesi', day4: 'Salı', day5: 'Çarşamba', day6: 'Perşembe', day7: 'Cuma',
    profile: 'Profil', login: 'Giriş yap',
    loginWithGoogle: 'Google ile devam et', logout: 'Çıkış',
    categories: 'Kategoriler', allRecipes: 'Tüm tarifler', servings: 'Kişi',
    prepTime: 'Hazırlık', cookTime: 'Pişirme', minutes: 'dk',
    ingredients: 'Malzemeler', tools: 'Aletler', steps: 'Adımlar',
    addToShopping: 'Alışverişe ekle', addedToShopping: 'Eklendi',
    addAll: 'Hepsini ekle', startTimer: 'Başlat', pauseTimer: 'Duraklat', resetTimer: 'Sıfırla',
    next: 'Sonraki', prev: 'Önceki', saveFav: 'Kaydet', removeFav: 'Kaldır',
    needLogin: 'Önce giriş yapın', searchByIngredients: 'Malzemeyle ara',
    typeIngredient: 'Malzeme yazın', searchPlaceholder: 'örn: yumurta + un + süt',
    searchBtn: 'Ara', matchedIngr: 'eşleşen',
    aiAssistant: 'AI Asistan', aiAsk: 'Tarif öner',
    askPlaceholder: 'örn: yumurta ve peynirim var', diet: 'Diyet',
    dietAny: 'Herhangi', dietKeto: 'Keto', dietVegan: 'Vegan', dietHealthy: 'Sağlıklı',
    voiceCommand: 'Sesli komut', voiceListening: 'Dinleniyor...',
    voiceHelp: 'De: sonraki, önceki, başlat',
    premiumTitle: 'Premium tarifler', premiumDesc: 'Şef tarifleri reklamsız',
    monthly: '/ay', subscribe: 'Abone ol', soonLabel: 'Yakında',
    startTrial: '7 gün ücretsiz deneme', trialActive: 'Deneme aktif', trialDays: 'ücretsiz gün',
    shoppingEmpty: 'Liste boş', addItem: 'Ekle', itemName: 'Ad', qty: 'Adet',
    bought: 'Alındı', remove: 'Sil', onlineShop: 'Online sipariş',
    favEmpty: 'Henüz favori yok', backHome: 'Ana sayfa',
    welcomeBack: 'Tekrar hoşgeldin', loginDesc: 'Kaydetmek için giriş yapın',
    suggested: 'Önerilen', explore: 'Keşfet', timerDone: 'Süre bitti!',
    step: 'Adım', of: '/', settings: 'Ayarlar', language: 'Dil',
    send: 'Gönder', aiThinking: 'Düşünüyor...',
  },
  ur: {
    appName: 'مطبخی', tagline: 'آپ کے ذائقے کی ترکیبیں',
    discover: 'دریافت', favorites: 'پسندیدہ', search: 'تلاش', shopping: 'خریداری',
    premium: 'پریمیم',
    weekPlan: 'ہفتہ کا منصوبہ', tracker: 'کیلوری ٹریکر',
    setupProfile: 'پروفائل', weight: 'وزن (کلو)', height: 'قد (سینٹی میٹر)', age: 'عمر',
    gender: 'جنس', male: 'مرد', female: 'عورت',
    activity: 'سرگرمی', sedentary: 'بے حرکت', light: 'ہلکی', moderate: 'درمیانی', active: 'فعال',
    goal: 'مقصد', lose: 'وزن کم', maintain: 'برقرار', gain: 'وزن بڑھانا',
    save: 'محفوظ', dailyTarget: 'روزانہ ہدف', consumed: 'کھایا', remaining: 'باقی',
    todayLog: 'آج کا ریکارڈ', addMeal: 'کھانا شامل', mealName: 'نام',
    customMeal: 'حسب پسند', fromRecipe: 'ترکیب سے', weekHistory: 'پچھلے 7 دن',
    profileSaved: 'پروفائل محفوظ', mealAdded: 'کھانا شامل', pickRecipe: 'ترکیب چنیں', kcal: 'کیلوری', perServing: 'فی حصہ', nutrition: 'غذائیت',
    protein: 'پروٹین', carbs: 'کاربس', fat: 'چربی', totalWeek: 'ہفتہ کل',
    regenerate: 'نیا منصوبہ', savePlan: 'محفوظ', addPlanShopping: 'تمام اجزاء شامل',
    planSaved: 'منصوبہ محفوظ', planAdded: 'اجزاء شامل',
    day1: 'ہفتہ', day2: 'اتوار', day3: 'سوموار', day4: 'منگل', day5: 'بدھ', day6: 'جمعرات', day7: 'جمعہ',
    profile: 'پروفائل', login: 'لاگ ان',
    loginWithGoogle: 'گوگل سے جاری رکھیں', logout: 'لاگ آؤٹ',
    categories: 'اقسام', allRecipes: 'تمام ترکیبیں', servings: 'افراد',
    prepTime: 'تیاری', cookTime: 'پکانا', minutes: 'منٹ',
    ingredients: 'اجزاء', tools: 'آلات', steps: 'مراحل',
    addToShopping: 'خریداری میں شامل کریں', addedToShopping: 'شامل کر دیا گیا',
    addAll: 'سب شامل کریں', startTimer: 'شروع', pauseTimer: 'روکیں', resetTimer: 'ری سیٹ',
    next: 'اگلا', prev: 'پچھلا', saveFav: 'محفوظ کریں', removeFav: 'ہٹائیں',
    needLogin: 'پہلے لاگ ان کریں', searchByIngredients: 'اجزاء سے تلاش',
    typeIngredient: 'جزو لکھیں', searchPlaceholder: 'مثلاً: انڈا + آٹا + دودھ',
    searchBtn: 'تلاش', matchedIngr: 'مماثل',
    aiAssistant: 'اے آئی معاون', aiAsk: 'ترکیب تجویز کریں',
    askPlaceholder: 'مثلاً: میرے پاس انڈے ہیں', diet: 'غذا',
    dietAny: 'کوئی بھی', dietKeto: 'کیٹو', dietVegan: 'ویگن', dietHealthy: 'صحت بخش',
    voiceCommand: 'آواز کمانڈ', voiceListening: 'سن رہا ہے...',
    voiceHelp: 'کہیں: اگلا، پچھلا',
    premiumTitle: 'پریمیم ترکیبیں', premiumDesc: 'شیف ترکیبیں اشتہار کے بغیر',
    monthly: '/ماہ', subscribe: 'سبسکرائب', soonLabel: 'جلد',
    startTrial: '7 دن مفت آزمائش', trialActive: 'آزمائش جاری', trialDays: 'مفت دن',
    shoppingEmpty: 'فہرست خالی ہے', addItem: 'شامل کریں', itemName: 'نام', qty: 'مقدار',
    bought: 'خریدا', remove: 'حذف', onlineShop: 'آن لائن آرڈر',
    favEmpty: 'کوئی پسندیدہ نہیں', backHome: 'ہوم',
    welcomeBack: 'خوش آمدید', loginDesc: 'محفوظ کرنے کے لیے لاگ ان کریں',
    suggested: 'تجویز', explore: 'دریافت', timerDone: 'وقت ختم!',
    step: 'مرحلہ', of: 'از', settings: 'ترتیبات', language: 'زبان',
    send: 'بھیجیں', aiThinking: 'سوچ رہا ہے...',
  },
};

export function t(lang, key) {
  return (TRANSLATIONS[lang] || TRANSLATIONS.en)[key] || TRANSLATIONS.en[key] || key;
}
